export const menus = {
    name: 'Menus',
    position: 2,
    route: '/',
    fields: [],
};
